import Vue from "vue";
import Router from "vue-router";
import BookmarksHome from "./components/bookmarks/views/BookmarksHome";
import BookmarksResources from "./components/bookmarks/views/BookmarksResources";
import MyHome from "./components/books/views/MyHome";
import MyHomeBooks from "./components/books/views/MyHomeBooks";
import MyHomeHome from "./components/books/views/MyHomeHome";
import Sidebar from "./components/events/components/Sidebar";
import SidebarEvents from "./components/events/components/SidebarEvents";
import EventsDownload from "./components/events/views/EventsDownload";
import EventsDownloadCertificate from "./components/events/views/EventsDownloadCertificate";
import EventsEditLaboratories from "./components/events/views/EventsEditLaboratories";
import EventsList from "./components/events/views/EventsList";
import EventsMain from "./components/events/views/EventsMain";
import EventsPersonalData from "./components/events/views/EventsPersonalData";
import EventsSelectedEvent from "./components/events/views/EventsSelectedEvent";
import EventsSurvey from "./components/events/views/EventsSurvey";
import conf from "./appConf";
import SidebarBookmarksResources from "~/components/bookmarks/components/SidebarBookmarksResources";
import SidebarBookmarksDeALive from "~/components/bookmarks/components/SidebarBookmarksDeALive";
import SidebarBookmarksEvents from "~/components/bookmarks/components/SidebarBookmarksEvents";
import BookmarksDeALive from "~/components/bookmarks/views/BookmarksDeALive";
import BookmarksEvents from "~/components/bookmarks/views/BookmarksEvents";
import MyProfileHome from "~/components/myProfile/views/MyProfileHome";
import MyProfileData from "~/components/myProfile/views/MyProfileData";
import MyProfileFamily from "~/components/myProfile/views/MyProfileFamily";
import MyProfileMySchool from "~/components/myProfile/views/MyProfileMySchool";
import MyProfileSchools from "~/components/myProfile/views/MyProfileSchools";
import MyProfilePrivacy from "~/components/myProfile/views/MyProfilePrivacy";
import MyProfileNotifications from "~/components/myProfile/views/MyProfileNotifications";
import MyProfileOrdersPanels from "~/components/myProfile/views/MyProfileOrdersPanels";
import MyProfileOrdersList from "~/components/myProfile/views/MyProfileOrdersList";
import MyProfileSupport from "~/components/myProfile/views/MyProfileSupport";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      component: MyHome,
      children: [
        {
          path: "",
          name: "home",
          component: MyHomeHome,
        },
        {
          path: "books",
          name: "books",
          component: MyHomeBooks,
        },
        {
          path: "bookmarks",
          name: "bookmarks",
          component: BookmarksHome,
          children: [
            {
              path: "resources",
              name: "bookmarks-resources",
              component: BookmarksResources,
              props: {
                mainTitle: "Le mie risorse salvate",
                sidebarComponent: SidebarBookmarksResources,
              },
            },

            {
              path: "dealive",
              name: "bookmarks-dealive",
              component: BookmarksDeALive,
              props: {
                mainTitle: "I miei articoli Dlive preferiti",
                sidebarComponent: SidebarBookmarksDeALive,
              },
            },

            {
              path: "events",
              name: "bookmarks-events",
              component: BookmarksEvents,
              props: {
                mainTitle: "Corsi che mi interessano",
                sidebarComponent: SidebarBookmarksEvents,
              },
            },
          ],
        },
        {
          path: "event",
          component: EventsMain,
          children: [
            {
              path: "",
              name: "events",
              component: EventsList,
              props: {
                mainTitle: "I miei prossimi corsi",
                sidebarComponent: SidebarEvents,
                headerSecondaryTitle: "Vai all'Area Personale Deascuola",
                headerSecondaryUrl: conf.myhome_url,
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "dati/:registration/",
              name: "personal-data",
              component: EventsPersonalData,
              props: {
                mainTitle: "Completa il questionario",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
                updateUser: true,
              },
            },
            {
              path: "questionario/:registration/",
              name: "survey",
              component: EventsSurvey,
              props: {
                mainTitle: "Questionario di valutazione",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "certificati/:registration/",
              name: "certificate",
              component: EventsDownloadCertificate,
              props: {
                mainTitle: "Grazie!",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "laboratori/:registration/",
              name: "laboratories",
              component: EventsEditLaboratories,
              props: {
                mainTitle: "Modifica laboratori",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "documenti/:registration/",
              name: "download",
              component: EventsDownload,
              props: {
                mainTitle: "Scarica i materiali",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale",
                headerSecondaryUrl: "#/",
                headerSecondaryExtraTitle: "Vai a Deascuola Formazione",
                headerSecondaryExtraUrl: "https://formazione.deascuola.it/",
              },
            },
            {
              path: "iscrizione/:registration/",
              name: "registration",
              component: EventsSelectedEvent,
              props: {
                mainTitle: "Il mio corso",
                sidebarComponent: Sidebar,
                headerSecondaryTitle: "Torna all'Area Personale Deascuola",
                headerSecondaryUrl: conf.myhome_url,
                headerSecondaryExtraTitle: "Torna ai miei corsi",
                headerSecondaryExtraUrl: "#/",
              },
            },
          ],
        },
        {
          path: "my-profile",
          name: "my-profile",
          component: MyProfileHome,
          children: [
            {
              path: "data",
              name: "my-profile-data",
              component: MyProfileData,
            },
            {
              path: "family",
              name: "my-profile-family",
              component: MyProfileFamily,
            },
            {
              path: "my-school",
              name: "my-profile-my-school",
              component: MyProfileMySchool,
            },
            {
              path: "schools",
              name: "my-profile-schools",
              component: MyProfileSchools,
            },
            {
              path: "privacy",
              name: "my-profile-privacy",
              component: MyProfilePrivacy,
            },
            {
              path: "notifications",
              name: "my-profile-notifications",
              component: MyProfileNotifications,
            },
            {
              path: "support",
              name: "my-profile-support",
              component: MyProfileSupport,
            },
            {
              path: "orders",
              name: "my-profile-orders-panels",
              component: MyProfileOrdersPanels,
            },
            {
              path: "orders-dea",
              name: "orders-dea",
              component: MyProfileOrdersList,
            },
          ],
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.afterEach(to => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "pageviewCustomEvent",
      pagePath: `${to.path}`,
      pageTitle: `Area Personale - ${to.name}`,
    });
  }
});

export default router;
